import React from 'react'
import Ide from '../../components/Ide.js'
import Topbar from './Htmltopbar'
import './Lessons.css'
import Slide1 from './slides/slide1.png'
import Slide2 from './slides/slide2.png'
import Slide3 from './slides/slide3.png'




export default function Environment() {

  const handleClick = () => {
    if (document.getElementsByClassName("presentation")[0].style.width = "300px")  {
      document.getElementsByClassName("presentation")[0].style.width = "200px"
      document.getElementsByClassName("links")[0].style.display = "flex"
      document.getElementById("pres").style.left = "940px";
      document.getElementById("pres").style.top = "340px";
    }
    

    if (document.getElementsByClassName("slidecontainer")[0].style.width = "300px") {
      document.getElementsByClassName("presentation")[0].style.width = "200px"
      document.getElementsByClassName("slidecontainer")[0].style.width = "200px"
      document.getElementsByClassName("menu")[0].style.width = "200px"
      document.getElementsByClassName("links")[0].style.display = "flex"
    
    document.getElementById("pres").style.left = "940px";
    document.getElementById("pres").style.top = "340px";

    }
  }

  const mobilehandleClick = () => {
    if (document.getElementsByClassName("presentation")[0].style.width = "300px" ) {
      document.getElementsByClassName("presentation")[0].style.width = "180px"
      document.getElementsByClassName("presentation")[0].style.height = "210px"
      document.getElementsByClassName("links")[0].style.display = "none"
    document.getElementById("pres").style.left = "32px";
    document.getElementById("pres").style.top = "400px";
    }

    if (document.getElementsByClassName("slidecontainer")[0].style.width = "300px") {
      document.getElementsByClassName("presentation")[0].style.width = "180px"
      document.getElementsByClassName("slidecontainer")[0].style.width = "180px"
      document.getElementsByClassName("menu")[0].style.width = "180px"
      document.getElementsByClassName("presentation")[0].style.height = "210px"
      document.getElementsByClassName("links")[0].style.display = "none"
    
    document.getElementById("pres").style.left = "32px";
    document.getElementById("pres").style.top = "400px";
    }

  }


  const altClick = () => {
    if (document.getElementsByClassName("presentation")[0].style.width = "200px" ) {
      document.getElementsByClassName("presentation")[0].style.width = "300px"
      document.getElementsByClassName("slidecontainer")[0].style.width = "300px"
      document.getElementsByClassName("menu")[0].style.width = "300px"
      document.getElementsByClassName("links")[0].style.display = "flex"
    }
    document.getElementById("pres").style.left = "460px";
    document.getElementById("pres").style.top = "135px";
  }

  
  const mobilealtClick = () => {
    if (document.getElementsByClassName("presentation")[0].style.width = "200px" ) {
      document.getElementsByClassName("presentation")[0].style.width = "300px"
      document.getElementsByClassName("presentation")[0].style.height = "330px"
      document.getElementsByClassName("slidecontainer")[0].style.width = "300px"
      document.getElementsByClassName("menu")[0].style.width = "300px"
      document.getElementsByClassName("links")[0].style.display = "none"
    document.getElementById("pres").style.left = "30px";
    document.getElementById("pres").style.top = "200px";
    }

  }

  const mobileClick = () => {
    if (document.getElementsByClassName("slidecontainer")[0].style.width == "50px" ) {
      document.getElementsByClassName("slidecontainer")[0].style.width = "300px"
      document.getElementsByClassName("links")[0].style.display = "none"
      document.getElementsByClassName("menu")[0].style.display = "flex"
      document.getElementsByClassName("menu")[0].style.width = "300px"
      document.getElementById("pres").style.left = "30px";
      document.getElementById("pres").style.top = "200px";
    }
   
    if (document.getElementsByClassName("slidecontainer")[0].style.width == "200px" ) {
      document.getElementsByClassName("slidecontainer")[0].style.width = "300px"
      document.getElementsByClassName("links")[0].style.display = "flex"
      document.getElementsByClassName("menu")[0].style.display = "flex"
      document.getElementsByClassName("menu")[0].style.width = "300px"
      document.getElementById("pres").style.left = "460px";
      document.getElementById("pres").style.top = "135px";
    }

    if (document.getElementsByClassName("slidecontainer")[0].style.width == "180px" ) {
      document.getElementsByClassName("slidecontainer")[0].style.width = "300px"
      document.getElementsByClassName("links")[0].style.display = "none"
      document.getElementsByClassName("menu")[0].style.display = "flex"
      document.getElementsByClassName("menu")[0].style.width = "300px"
      document.getElementById("pres").style.left = "30px";
      document.getElementById("pres").style.top = "200px";
    }
  }

  const reduceClick = () => {
    if (document.getElementsByClassName("presentation")[0].style.width = "200px" ) {
      document.getElementsByClassName("presentation")[0].style.width = "50px"
      document.getElementsByClassName("presentation")[0].style.height = "50px"
      document.getElementsByClassName("slidecontainer")[0].style.width = "50px"
      document.getElementsByClassName("links")[0].style.display = "none"
      document.getElementsByClassName("menu")[0].style.display = "none"
    }
    document.getElementById("pres").style.left = "310px";
    document.getElementById("pres").style.top = "6px";
  }
 

  return (
    <div className='environment'>
      <Topbar />
      <Ide /> 
      
      <div className='presentation' id='pres'>
        <div className='menu'>
        <div className='buttons'>
        <button id='mobileminimize' onClick={mobilehandleClick}></button>
        <button id='minimize' onClick={handleClick}></button>
        <button id='min'></button>
        <button id='mobilemin' onClick={reduceClick}></button>
        <button id='maximize' onClick={altClick}></button>        
        <button id='mobilemaximize' onClick={mobilealtClick}></button>        
        </div>
        <div className='links'>     
          <a href='#slide1'><p></p></a>
          <a href='#slide2'><p></p></a>
          <a href='#slide3'><p></p></a>
          <a href='#slide1'><p></p></a>
          <a href='#slide2'><p></p></a>
          <a href='#slide3'><p></p></a>
          <a href='#slide1'><p></p></a>
          <a href='#slide2'><p></p></a>
          <a href='#slide3'><p></p></a>
        </div>
        </div>

        <div className='slidecontainer' onClick={mobileClick}>
        <div className='slide' id='slide1'><img src= {Slide1} /></div>
        <div className='slide' id='slide2'><img src= {Slide2} /></div>
        <div className='slide' id='slide3'><img src= {Slide3} /></div>
        <div className='slide' id='slide1'><img src= {Slide1} /></div>
        <div className='slide' id='slide2'><img src= {Slide2} /></div>
        <div className='slide' id='slide3'><img src= {Slide3} /></div>
        <div className='slide' id='slide1'><img src= {Slide1} /></div>
        <div className='slide' id='slide2'><img src= {Slide2} /></div>
        <div className='slide' id='slide3'><img src= {Slide3} /></div>
        </div> 

      </div>
    </div>
  )
}
